import {
  queryBuildingList,
  getBedroomList,
  getManageSave,
  getDormitoryManagelist,
  getManageDelete,
  getManagedetail,
} from '../services/services';

const initState = {
  attendanceObjectVisible: false,
  deptDetailData: [],
  deptDetailTotalNumber: 0,
};

export default {
  namespace: 'manageGroup',
  state: initState,
  effects: {
    *fetchBuildingList({ params }, { call }) {
      try {
        const response = yield call(queryBuildingList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchBedroomList({ params }, { call }) {
      try {
        const response = yield call(getBedroomList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchManageSave({ params }, { call }) {
      try {
        const response = yield call(getManageSave, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchDormitoryManagelist({ params }, { call }) {
      try {
        const response = yield call(getDormitoryManagelist, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchManageDelete({ params }, { call }) {
      try {
        const response = yield call(getManageDelete, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchManagedetail({ params }, { call }) {
      try {
        const response = yield call(getManagedetail, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
